// File: components/mobile/RequirePackerAuth.tsx

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase'; // Adjusted path

export const RequirePackerAuth = ({ children }: { children: JSX.Element }) => {
  const [session, setSession] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (!session) {
        // Not logged in? Go to Android Login
        navigate('/android-login');
      } else {
        setSession(session);
      }
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!session) navigate('/android-login');
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  if (loading) return <div className="fixed inset-0 bg-black z-50" />; // Black loading screen
  
  return session ? children : null;
};
